/**
 * 基版コピー・フェーズ管理画面　基版コピー・フェーズ管理情報VOクラス
 */
export class KYMW2700GetCatalogPageProgressModel {

  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分

}
